<form [formGroup]="form">
  <div class="input-error">
    <input
      type="text"
      [placeholder]="(placeholder || '') | translate"
      formControlName="text"
      class="light-grey-placeholder">
    <cc-input-errors
      [form]="form"
      inputName="text"
      [errors]="[{'required': errorMessage}, {'pattern': errorMessage}]"></cc-input-errors>
  </div>
</form>
